import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { OptionNumberModule, OptionTextModule } from '../../options';
import { QuestionCheckboxComponent } from './question-checkbox.component';

@NgModule({
  imports: [QuestionModule, OptionNumberModule, OptionTextModule],
  declarations: [QuestionCheckboxComponent],
  exports: [QuestionCheckboxComponent]
})
export class QuestionCheckboxModule {}
